(function (angular) {
  "use strict";

  angular.module("app").directive("event", eventDirective);

  eventDirective.$inject = ["EventsApi", "Events", "thisSiteSettings"];

  function eventDirective(EventsApi, Events, thisSiteSettings) {
    function eventLink($scope) {
      $scope.thisSiteSettings = thisSiteSettings;

      // properties
      $scope.isLoading = false;

      // methods
      $scope.manageAttendance = manageAttendance;

      /**
       * Opens modal with attend event form
       * @param  {object} event - API event object
       * @return {void}
       */
      function manageAttendance(event, e) {
        e.preventDefault();

        Events.manageAttendance(event.id).result.then(function (modifiedEvent) {
          angular.merge($scope.event, modifiedEvent);
        });
      }
    }

    return {
      restrict: "E",
      templateUrl: "directives/event.html",
      transclude: true,
      link: eventLink,
      scope: {
        event: "=", // event object
        hideAttendButton: "=?",
        attended: "=?",
      },
    };
  }
})(angular);
